// AnimatedTestimonialsDemo.js
import React from "react";
import { useTranslation } from "react-i18next";
import AnimatedTestimonials from "./Testimonials";
import dheerendraProfile from "./images/team/dheerendra-profile.jpg";
import bharathProfile from "./images/team/bharath-profile.webp";
import vijayProfile from "./images/team/vijay-profile.webp";
import gopalProfile from "./images/team/gopal-profile.webp";
import "./styles/Exeteam.css";

export default function AnimatedTestimonialsDemo() {
    const { t } = useTranslation();
    const testimonials = [
        {
            src: dheerendraProfile,
            name: "Dheerendra V Purohit",
            designation: t('exeteam.dheerendraDesignation'),
            description: t('exeteam.dheerendraDescription'),
        },
        {
            src: gopalProfile,
            name: "Gopalkrishnan Lakshmi",
            designation: t('exeteam.gopalDesignation'),
            description: t('exeteam.gopalDescription'),
        },
        {
            src: vijayProfile,
            name: "Vijay Mangalpally",
            designation: t('exeteam.vijayDesignation'),
            description: t('exeteam.vijayDescription'),
        },
        {
            src: bharathProfile,
            name: "Bharath Renukaswamy",
            designation: t('exeteam.bharathDesignation'),
            description: t('exeteam.bharathDescription'),
        },
    ];

    return (
        <div className="animated-testimonials-demo">


            <AnimatedTestimonials testimonials={testimonials} />
        </div>
    );
}

